import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
} from 'amazon-cognito-identity-js';

import { COGNITO_REGION } from './tenants';

/**
 * Create a CognitoUserPool instance for the given tenant config.
 *
 * @param {{ userPoolId: string, clientId: string }} tenantConfig
 * @returns {CognitoUserPool}
 */
export function createUserPool(tenantConfig) {
  return new CognitoUserPool({
    UserPoolId: tenantConfig.userPoolId,
    ClientId: tenantConfig.clientId,
  });
}

/**
 * Create a CognitoUser instance for the given email + tenant config.
 *
 * @param {string} email
 * @param {CognitoUserPool} userPool
 * @returns {CognitoUser}
 */
export function createCognitoUser(email, userPool) {
  return new CognitoUser({
    Username: email.toLowerCase().trim(),
    Pool: userPool,
  });
}

/**
 * Create AuthenticationDetails for SRP authentication.
 *
 * @param {string} email
 * @param {string} password
 * @returns {AuthenticationDetails}
 */
export function createAuthDetails(email, password) {
  return new AuthenticationDetails({
    Username: email.toLowerCase().trim(),
    Password: password,
  });
}

/**
 * Resolve the Cognito region.
 */
export { COGNITO_REGION };
